import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getSort } from 'selectors/algolia2/url'
import { getHrefFunction } from 'connectors/Facets/helper'

const mapStateToProps = createStructuredSelector({
  getHref: getHrefFunction,
  sort: getSort,
})

export type ConnectorProps = {
  getHref: (filterParam: Record<string, any>) => string
  sort: string
}

export default connect(mapStateToProps)
